import { supabase } from "../lib/api";
import { LinkStatus } from "./addLink";

type UpdateLinkStatusProps = {
  newStatus: LinkStatus;
  linkId: number;
};

export const updateLinkStatus = async (props: UpdateLinkStatusProps) => {
  const { newStatus, linkId } = props;
  // ok = 200
  return await supabase
    .from("links")
    .update({ status: newStatus, published_at: new Date() })
    .eq("id", linkId)
    .select();
};
